// extracted by mini-css-extract-plugin
export default {"license_data_container":"LicenseData_license_data_container__cu-8f"};